import { defineComponent as e } from "vue";
import "./TripleBounce.css";
const n = e({
  name: "TripleBounce",
  props: {
    size: { type: Number, default: 0 },
    color: { type: String, default: "" }
  },
  computed: {
    spinnerColor() {
      return this.color || "#ccc";
    },
    spinnerSize() {
      return (this.size || 28) / 3 + "px";
    },
    bounceStyle() {
      return {
        width: this.spinnerSize,
        height: this.spinnerSize,
        backgroundColor: this.spinnerColor
      };
    }
  }
});
export {
  n as default
};
